import React, { SyntheticEvent, FC, memo } from 'react';

import { useTranslation } from 'react-i18next';

import { SpInput } from '@/components/Common/Sp';
import AuthSubmitButton from '../AuthSubmitButton';
import { validateEmail } from '../../validators';

const nameSpace = 'forgotPassword.firstStep';

interface EnterEmailProps {
    email: string;
    onSubmit: (event: SyntheticEvent) => void;
    onChange: (email: string) => void;
}

const EnterEmail: FC<EnterEmailProps> = ({ onSubmit, onChange, email }) => {
    const { t } = useTranslation();

    return (
        <div>
            <form onSubmit={onSubmit}>
                <SpInput
                    data-testid="forgotPassword_emailInput"
                    type="text"
                    value={email}
                    placeholder={t(`${nameSpace}.placeholder`)}
                    onChange={onChange}
                />
                <AuthSubmitButton
                    data-testid="forgotPassword_resetButton"
                    isLimitedWidth
                    disabled={!validateEmail(email)}
                    onClick={onSubmit}
                    titleKey={`${nameSpace}.reset`}
                />
            </form>
        </div>
    );
};

export default memo(EnterEmail);
